export default __webpack_public_path__ + "static/08.01-d24f622703827a9f3193e79cea37fec2.png";